import React from "react";
import { WithdrawForm } from "../../../components/Saving";
import { Loading } from "../../../components/Loader";
import toastMessage from "../../../components/toastMessage";
import axios from "axios";

class Withdraw extends React.Component {
  constructor() {
    super();

    this.state = {
      error: {},
      data: [],
      isSubmitting: false,
      balance: 0,
    };
  }

  componentDidMount() {
    this.getBalance();
    this.getFleets();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.savingInfo !== this.props.savingInfo) {
      this.getBalance();
      this.getFleets();
    }
  }

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];
    this.setState({ error, [field]: e.target ? e.target.value : e });
  }

  getFleets() {
    this.setState({ isLoading: true });
    let { ztoken, savingInfo } = this.props;

    const config = {
      method: "GET",
      url: `${process.env.REACT_APP_MOBITILL_URL}/fleets`,
      params: {
        appid: [savingInfo.app_id],
        clientid: [savingInfo.user_id],
      },
      headers: {
        Authorization: `Bearer ${ztoken}`,
      },
    };

    axios(config)
      .then((data) => {
        const fleets_array = data?.data?.data?.map(fleet => ({
          value: fleet.vehicleno,
          label: fleet.vehicleno
        }));

        this.setState({
          fleets: fleets_array,
          isLoading: false,
        });
      })
      .catch((error) => {
        toastMessage("error", error?.response?.data?.errors[0] || 'Failed to fetch fleets');
        this.setState({ isLoading: false });
      });
  }

  getBalance() {
    this.setState({ isLoading: true });

    let { ztoken, savingInfo } = this.props;

    const options = {
      method: "GET",
      url: `${process.env.REACT_APP_URL}/savings/balance/${savingInfo.user_id}`,
      headers: {
        Authorization: `Bearer ${ztoken}`,
      },
    };

    axios(options)
      .then((data) => {
        this.setState({
          balance: data?.data?.data?.balance || 0,
          isLoading: false,
        });
      })
      .catch((err) => {
        toastMessage("error", err.message);
        this.setState({
          isLoading: false,
        });
      });
  }

  validateForm() {
    let { error } = this.state;

    if (!this.state.narration || this.state.narration === 0) {
      error.narration = "Narration is required";
      this.setState({ error, isSubmitting: false });
      return;
    }

    if (!this.state.fleet) {
      error.fleet = "Fleet is required";
      this.setState({ error, isSubmitting: false });
      return;
    }

    if (!this.state.amount || this.state.amount === 0) {
      error.amount = "Amount is required";
      this.setState({ error, isSubmitting: false });
      return;
    }

    this.setState({ error });
  }

  handleSaveData = async () => {
    await this.validateForm();

    let { error } = this.state;

    if (Object.keys(error).length > 0) return;

    this.setState({ isSubmitting: true });

    let { amount, narration, fleet } = this.state,
      { savingInfo } = this.props;

    const input_data = {
      user_id: savingInfo.user_id,
      amount,
      narration,
      fleet,
    };

    const options = {
      method: "POST",
      url: `${process.env.REACT_APP_URL}/savings/withdraw`,
      data: input_data,
      headers: {
        Authorization: "Bearer " + this.props.ztoken,
      },
    };

    axios(options)
      .then((data) => {
        this.setState({
          isSubmitting: false,
          amount: 0,
        });
        toastMessage("success", data?.data?.message || "Withdrawal was successfully processed");

        this.getBalance();
        this.props.getSavings(true);
        this.props.handleSavingUpdatingAndNeedAutoRefresh &&
          this.props.handleSavingUpdatingAndNeedAutoRefresh();
      })
      .catch((err) => {
        this.setState({ isSubmitting: false });
        toastMessage("error", err.response?.data?.error || err.response?.message);
      });
  };

  render() {
    const { error, amount, isSubmitting, isLoading, balance, fleets } = this.state;
    return (
      <div className="content-cont">
        {isLoading ? (
          <Loading icon="fa fa-spinner fa-spin" />
        ) : (
          <WithdrawForm
            fleets={fleets}
            error={error}
            balance={balance}
            amount={amount}
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            handleSaveData={this.handleSaveData.bind(this)}
            onChangeText={this.onChangeText.bind(this)}
          />
        )}
      </div>
    );
  }
}

export default Withdraw;
